export default __webpack_public_path__ + "static/media/video_thumbnail.957eb24f.png";